module.exports = __webpack_public_path__ + "static/things-8780d398edeed46aaab6fd0643441af0.gif";